import React, { Component } from 'react';
import CSSModules from 'react-css-modules'
// import {SlideDown} from 'react-slidedown'
import ReactTooltip from 'react-tooltip'
import { Link as ScrollLink } from 'react-scroll'
import {Row, Col} from 'react-flexbox-grid'
// import ReactPlayer from 'react-player'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  // Works,
  Link,
  LinkIcon,
  GetStartedInput,
  Grade,
  Changelog,
  ScrollToTop,
  AutocompleteSearch,
} from '../../components'
import Styles from './HowItWorks.css'


@CSSModules(Styles,{allowMultiple:true})
export default class HowItWorks extends Component {
  render() {
    const title = 'How it works'
    const description = 'LOREM IPSUM DESCRIPTION'
    const url = config.domain + config.routes.howitworks

    const logoEquileap = require('../../../static/images/logo-equileap.png')
    const logoAsYouSow = require('../../../static/images/AYS_R+large+RGB.jpg')
    const logoWhistleStop = require( '../../../static/images/about/whistle-stop-capital-logo.png' )
    const logoHrc = require('../../../static/images/logo-hrc.png')
    // const logoIyv = require('../../../static/images/iyv-logo-project-of-2021.jpg')
    const logoIyv = require( '../../../static/images/iyv-logo-sm.png' )
    const sriIcon = require( '../../../static/images/sri.png' )
    const ussifIcon = require( '../../../static/images/ussif-logo.png' )
    const pffIcon = require( '../../../static/images/icons/pff-icn-clr.png' )
    const wffIcon = require( '../../../static/images/icons/wff-icn-clr.png' )

    //
    return (
      <div styleName='page' id='top'>
        {container.helmet(title, description, url)}

        <ContainerDivs>
          <Row styleName='title-nav-row'>
            <Col xs={12} sm={8} styleName='title-nav-title'>
              <h1 styleName='title'>
                How it works
              </h1>
              { /* <p styleNameme='subtitle'>
                Getting started,
                methodology,
                and company data
              </p> */ }
              <p styleName='lede'>
                Social Justice Funds cross-references
                mutual fund holdings with in-depth company research
                to calculate portfolio ratings on gender equality,
                diversity disclosures, racial justice, and LGBTQ+ equity.
              </p>
            </Col>

            <Col xs={12} sm={4} styleName='title-nav-nav'>
              <nav styleName='page-nav'>
                <div styleName='page-nav-title'>
                  Contents
                </div>
                {
                  [
                    ['Getting started','getting-started'],
                    ['Company data','companies'],
                    ['Mutual fund grades','fund-grades'],
                    // ['Fund managers','fund-manager-ratings'],
                    ['Spreadsheet','spreadsheet'],
                  ].map((e, i) => {
                    return <ScrollLink
                      key={'nav-scroll-link-'+i}
                      to={e[1]}
                      spy
                      smooth
                      duration={500}
                      title={e[0]}
                    >
                      <div styleName='page-nav-btn'>
                        {e[0]}
                      </div>
                    </ScrollLink>
                  })
                }
              </nav>
            </Col>
          </Row>
        </ContainerDivs>

        { /* <Works/> */ }

        <ContainerDivs>
          <section styleName='methodology-section'>
            <div styleName='anchor' id='getting-started'/>
            <h2 styleName='section-title'>
              Getting started
            </h2>

            <h3 styleName='answer-title'>
              Finding your funds
            </h3>
            <div styleName='answer-info'>
              <p>
                We source data on
                companies and mutual funds from financial services provider
                Morningstar. Our database
                covers thousands of U.S. open-end mutual funds and
                exchange-traded funds (ETFs), some of the most common funds held in
                401(k)s, 403(b)s, and other retirement plans.
              </p>
              <p>
                Search for funds by name, ticker, or asset
                manager. Use the search bar below, or <Link
                  to={config.routes.clean}
                  title='Search funds'
                  xstrong
                >use the search page</Link> to do more advanced searches,
                such as filtering funds by investment strategy or
                asset manager.
              </p>

              <div styleName='search-bar-wrap'>

                <AutocompleteSearch />

                <div>
                  <Link
                    to={config.routes.clean}
                    title='Full fund list'
                    roundbutton
                  >Full fund list<LinkIcon /></Link>
                </div>

              </div>


              <div styleName='sidebar'>
                <div styleName='sidebar-title'>
                  <LinkIcon faclass='fa-info-circle' nospace/>
                  &nbsp;
                  <em>Our research universe</em>
                </div>
                <div styleName='sidebar-info'>
                  <p>
                    Our database covers open-end mutual funds and exchange-traded funds domiciled in the U.S. Currently, we don’t have ratings for funds domiciled outside the U.S., or funds traded as collective trusts or other investment vehicles.
                  </p>
                  <p>
                    The fund ratings are based on tracking stock investments in publicly-traded companies. Currently, we don’t have ratings for fixed income funds. Funds with less than 50% of fund assets in equity holdings are excluded from the research universe.
                  </p>
                </div>
              </div>

              <div styleName='sidebar f'>
                <div>
                  <div styleName='sidebar-title'>
                    <LinkIcon faclass='fa-question-circle' nospace/>
                    &nbsp;
                    <em>Can't find your funds?</em>
                  </div>
                  <div styleName='sidebar-info'>
                    <p>
                      Looking for your favorite fund and
                      can&rsquo;t find it? With more resources, we could include more
                      funds &mdash; <Link
                        to={config.links.donate}
                        title='Donate to As You Sow'
                        xstrong
                      >make a gift today to make a difference.</Link>
                    </p>
                  </div>
                </div>
                <div>
                  <Link
                    to={config.links.donate}
                    title='Donate to As You Sow'
                    donatebanner
                  >Donate&nbsp;&nbsp;<LinkIcon faclass='fa-heart'/></Link>
                </div>
              </div>

            </div>
            <ScrollToTop />
          </section>


          <section styleName='methodology-section'>
            <div styleName='anchor' id='companies'/>
            <h2 styleName='section-title'>
              Company data
            </h2>


            <h3 styleName='answer-title'>
              Social justice scorecards from issue experts
            </h3>
            <div styleName='answer-info'>
              <p>
                Our fund ratings are built on a foundation of in-depth company research on
                gender equality, diversity disclosures, racial justice, and LGBTQ+ equity.
              </p>
            </div>

            <h3 styleName='answer-title'>
              Gender equality
            </h3>
            <div styleName='answer-info-flex'>
              <div>
                <p>
                  Gender equality ratings are calculated
                  using data from the <Link
                    to={config.links.gefScorecard}
                    title='Equileap Gender Equality Scorecard'
                    xstrong
                  >
                    Equileap Gender Equality Scorecard
                  </Link> from <b>Equileap</b>.

                  The <b>Equileap Gender Equality Scorecard</b> covers
                  over 3,500 companies traded across global markets.

                  Each company is assessed on 19 criteria, including gender
                  balance across the workforce, the gender pay gap,
                  paid parental leave, and anti-sexual harassment policies.

                  Equileap gathers publicly available information provided by
                  the companies, including in their annual reports,
                  sustainability reports and/or on their websites.

                  Each company is assigned a gender equality score between
                  0 and 100.

                  For more details, refer to the <Link
                    to={config.links.gefScorecard}
                    title='Equileap Gender Equality Scorecard'
                    xstrong
                  >Equileap Gender Equality Global Report and Ranking</Link>.
                </p>
              </div>
              <div styleName='research-provider-logo-wrap'>
                <img src={logoEquileap} alt='Equileap' styleName='research-provider-logo-img' />
              </div>
            </div>

            <h3 styleName='answer-title'>
              Diversity disclosures
            </h3>
            <div styleName='answer-info-flex'>
              <div>
                <p>
                  Diversity disclosure ratings are calculated
                  using data from the <Link
                    to={config.links.deiScorecard}
                    title='Workplace Equity Disclosure Scorecard'
                    xstrong
                  >
                    Workplace Equity Disclosure Scorecard
                  </Link> from <b>Whistle Stop Capital</b> and <i>As You Sow</i>.

                  The <b>Workplace Equity Disclosure Scorecard</b> covers
                  3,000 U.S. companies.

                  Whistle Stop Capital gathers publicly available
                  information from company annual reports,
                  sustainability reports, and/or on their websites.

                  For more details, visit the <Link
                    to={config.links.deiScorecard}
                    title='Workplace Equity Disclosure Scorecard'
                    xstrong
                  ><i>As You Sow</i> website</Link>.
                </p>
              </div>
              <div styleName='research-provider-logo-wrap'>
                <img src={logoWhistleStop} alt='Whistle Stop Capital' styleName='research-provider-logo-img' />
              </div>
            </div>

            <h3 styleName='answer-title'>
              Racial justice
            </h3>
            <div styleName='answer-info-flex'>
              <div>
                <p>
                  Racial justice ratings are calculated
                  using data from <Link
                    to={config.links.rjiScorecard}
                    title="As You Sow's Racial Justice Scorecard"
                    xstrong
                  >
                    <i>As You Sow</i>'s Racial Justice Scorecard
                  </Link>.

                  The <b>Racial Justice Scorecard</b> covers
                  3,000 U.S. companies.

                  As You Sow gathers publicly available
                  information from company annual reports,
                  sustainability reports, and/or on their websites.

                  For more details, visit the <Link
                    to={config.links.rjiScorecard}
                    title="As You Sow's Racial Justice Scorecard"
                    xstrong
                  ><i>As You Sow</i> website</Link>.
                </p>
              </div>
              <div styleName='research-provider-logo-wrap'>
                <img src={logoAsYouSow} alt='As You Sow' styleName='research-provider-logo-img' />
              </div>
            </div>


            <h3 styleName='answer-title'>
              LGBTQ+ equity
            </h3>
            <div styleName='answer-info-flex'>
              <div>
                <p>
                  LGBTQ+ equity ratings are calculated
                  using data from the <Link
                    to={config.links.hrcScorecard}
                    title='Corporate Equality Index'
                    xstrong
                  >
                    Corporate Equality Index
                  </Link> from <b>Human Rights Campaign</b> (HRC).

                  The <b>HRC Corporate Equality Index</b> covers over
                  1,500 U.S. companies.

                  HRC gathers information with company surveys,
                  with additional research for
                  a subset of companies.

                  For more details, refer to the
                  <Link
                    to={config.links.hrcScorecard}
                    title='Corporate Equality Index'
                    xstrong
                  >HRC Corporate Equality Index.</Link>
                </p>
              </div>
              <div styleName='research-provider-logo-wrap'>
                <img src={logoHrc} alt='Human Rights Campaign' styleName='research-provider-logo-img' />
              </div>
            </div>


            <h3 styleName='answer-title'>
              Values-based exclusions
            </h3>
            <div styleName='answer-info-flex'>
              <div>
                <p>
                  Social Justice Funds is part of our <Link
                    to='https://investyourvalues.org'
                    xstrong
                    title='Invest Your Values'
                  >Invest Your Values</Link> program.
                  Since 2015, As You Sow has rated mutual funds on their
                  investments in companies contributing to environmental
                  and social risks.
                </p>
              </div>
              <div styleName='research-provider-logo-wrap'>
                <img src={logoIyv} alt='Invest Your Values' styleName='research-provider-logo-img' />
              </div>
            </div>

            <div styleName='answer-info-flex'>
              <div>
                <p>
                  <b>Prison & Border Industry</b> &mdash; The prison industrial
                  complex is a term used to describe the overlapping
                  interests of government and industry that use surveillance,
                  policing, and imprisonment as solutions to economic, social
                  and political problems.

                  We focus on two aspects of the
                  prison industrial complex: companies involved in the
                  prison industry (such as private for-profit prison
                    operators and prison services providers), and
                  companies involved in the militarization of borders and
                  the policing of immigration.

                  See the full list of companies
                  at <Link
                    to='https://prisonfreefunds.org'
                    xstrong
                    title='Prison Free Funds'
                  >Prison Free Funds</Link>.
                </p>
              </div>
              <div styleName='research-provider-logo-wrap'>
                <div styleName='hmi-icn-in'>
                  <img
                    src={pffIcon}
                    alt='Prison Free Funds'
                  />
                  <div styleName='hmi-icn-lbl'>
                    <span styleName='hmi-icn-lbl--prison'>Prison Free</span>
                    <span>&nbsp;Funds</span>
                  </div>
                </div>
              </div>
            </div>

            <div styleName='answer-info-flex'>
              <div>
                <p>
                  <b>Military Weapon Manufacturers</b> &mdash; Concerns
                  about human rights and social impact have led
                  weapon free investing to be a pillar of
                  sustainable investing for decades.

                  We focus on the largest publicly-traded arms
                  manufacturers and military contractors; companies
                  involved in the construction or maintenance of nuclear
                  weapons; and companies involved with other
                  controversial weapons, including cluster munitions,
                  anti-personnel landmines, incendiary weapons, and
                  depleted uranium.

                  See the full list of companies
                  at <Link
                    to='https://weaponfreefunds.org'
                    xstrong
                    title='Weapon Free Funds'
                  >Weapon Free Funds</Link>.
                </p>
              </div>
              <div styleName='research-provider-logo-wrap'>

                <div styleName='hmi-icn-in'>
                  <img
                    src={wffIcon}
                    alt='Weapon Free Funds'
                  />
                  <div styleName='hmi-icn-lbl'>
                    <span styleName='hmi-icn-lbl--weapon'>Weapon Free</span>
                    <span>&nbsp;Funds</span>
                  </div>
                </div>

              </div>
            </div>

            <ScrollToTop />
          </section>


          <section styleName='methodology-section'>
            <div styleName='anchor' id='fund-grades'/>
            <h2 styleName='section-title'>
              Mutual fund grades
            </h2>
            <h3 styleName='answer-title'>
              Analyzing fund portfolios
            </h3>
            <div styleName='answer-info'>
              <p>
                For each fund, we cross-reference the list of
                portfolio holdings with in-depth company research
                on social justice issues
                to calculate ratings on gender equality,
                diversity disclosures, racial justice, LGBTQ+ equity,
                prisons & borders, and military weapons.
              </p>
              <p>
                Mutual funds can have a varying number of holdings,
                from less than one hundred to several thousand.
                Holdings that are not stocks, like cash holdings or bonds,
                are not rated. In the fund's investment profile, we
                show a "Percent Rated" metric, equivalent to the percent
                of the fund that is invested in stocks. The higher a
                fund&rsquo;s Percent Rated value, the more holdings we
                were able to examine. A fund with a lower Percent Rated
                value may have hidden risky investments that our tool
                cannot account for, in the form of bond holdings or
                other asset types.
              </p>
              <div styleName='sidebar'>
                <div styleName='sidebar-title'>
                  <LinkIcon faclass='fa-info-circle' nospace/>
                  &nbsp;
                  <em>Long holdings only</em>
                </div>
                <div styleName='sidebar-info'>
                  <p>
                    When calculating a fund's exposure to a list of
                    companies, we only consider the portfolio's long
                    investments, ignoring any shorts or liabilities.
                    The formula for holding weight is <em>holding market
                    value divided by the sum of the market value for all
                    long holdings in the portfolio.</em>
                  </p>
                </div>
              </div>
            </div>

            <h3 styleName='answer-title'>
              Scoring fund portfolios
            </h3>
            <div styleName='answer-info'>
              <p>
                To calculate scores for mutual funds on gender equality,
                diversity disclosures, racial justice, and LGBTQ+ equity,

                we start with the company scores from the various company
                research sources.

                These sources include <b><i>As You
                Sow</i></b>, <b>Equileap</b>, <b>Human Rights
                Campaign</b>, and <b>Whistle Stop Capital</b>.
              </p>

              <p>
                Four company scorecards are cross-referenced with the holdings
                in each mutual fund.

                For each holding in a fund’s portfolio that is covered
                by a scorecard,

                we average the company-level scores, weighted by the amount
                the fund has invested, to calculate an overall
                score
                for the fund.


                When averaging, we weight the scores by the
                market value of the holding.
                This means if a fund has more money invested
                in one holding compared to another, the
                score of the holding with more assets
                invested counts more towards the average.
              </p>

              <p>
                Each of the funds we analyzed is based in the U.S.,
                is offered as an open-end mutual fund or ETF
                (as well as a handful of collective trusts and variable annuities),
                and is at least 50% invested in stocks.
              </p>
            </div>

            <h3 styleName='answer-title'>
              Ranking funds against peers
            </h3>
            <div styleName='answer-info'>
              <p>
                After funds are scored, they are grouped with peers and ranked.

                Funds are assigned to one of five
                groups based on investment strategy: <b>U.S.
                large cap equity funds</b>, <b>U.S. small cap
                equity funds</b>, <b>allocation
                funds</b>, <b>international
                equity funds</b>, and <b>sector
                equity funds</b>.

                Within these five groups, funds are ranked by their gender equality score,
                diversity disclosures score, racial justice score, and LGBTQ+ equity score.
              </p>

              <p>
                The rankings are presented as percentile rankings.

                If a fund earns a ranking of 75, that can be interpreted as: "This fund
                ranked better than or equal to 75% of the other funds in the same
                fund group." If a fund earns an overall ranking of 50, that can be
                read as: "This fund ranked better than or equal to 50% of all other
                funds in the dataset."
              </p>

              <p>
                To be ranked, a fund has at least 33% coverage
                for each scorecard – that is, at least 33% of the
                long-position holdings in the portfolio must be 
                stocks issued by companies that have data on that scorecard
                to be assigned a grade for that issue.
              </p>
            </div>

            <h3 styleName='answer-title'>
              Grading funds
            </h3>
            <div styleName='answer-info'>
              <p>
                Finally, an A-B-C-D-F letter grade is assigned based
                on which quintile the fund’s ranking places it: "A grade"
                funds are in the top 20% of their group, and so on, with
                "F grade" funds in the bottom 20% of their group.
              </p>
              <div styleName='risk-bullets'>
                <div styleName='risk-bullet'>
                  <Grade grade={1} square/>
                  <p styleName='screen-icon-label'>
                    Fund score is in 81st-100th percentile of group, the highest tier.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={2} square />
                  <p styleName='screen-icon-label'>
                    Fund score is in 61st-80th percentile of group.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={3} square />
                  <p styleName='screen-icon-label'>
                    Fund score is in 41st-60th percentile of group.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                  <Grade grade={4} square />
                  <p styleName='screen-icon-label'>
                    Fund score is in 21st-40th percentile of group.
                  </p>
                </div>
                <div styleName='risk-bullet'>
                <Grade grade={5} square />
                <p styleName='screen-icon-label'>
                  Fund score is in 1st-20th percentile of group, the lowest tier.
                </p>
                </div>
              </div>

              <br/>
              <p>
                In addition to the A-B-C-D-F grades, several funds earn a
                special Engagement Grade in recognition of strong efforts
                to promote gender equality, diversity disclosures, racial
                justice, and LGBTQ+ equity beyond the portfolio.
              </p>

              <div styleName='risk-bullets'>
                <div styleName='risk-bullet'>
                  <Grade grade={2.5} square/>
                  <p styleName='screen-icon-label'>
                    Fund earns an Engagement Grade, representing a firm
                    committment to corporate engagement, community and
                    stakeholder engagement, and impact investing in support
                    of equity and justice..
                  </p>
                </div>
              </div>

            </div>

            <h3 styleName='answer-title'>
              Sub-scores & KPIs
            </h3>
            <div styleName='answer-info'>
              <p>
                On each fund profile page, we also display various sub-scores for each of
                the four equity & justice ratings (gender equality, diversity disclosures,
                racial justice, and LGBTQ+ equity).

                The scorecards underlying these ratings
                each have a unique structure composed of various
                corporate key performance indicators (KPIs)
                that are organized into sub-sections.

                We use those scorecard KPI structures to calculate fund sub-scores.

                The sub-scores for each equity & justice ratings also display the full
                set of KPIs used to analyze the companies in the portfolio.
              </p>
            </div>

            <h3 styleName='answer-title'>
              Highest & lowest-scored holdings
            </h3>
            <div styleName='answer-info'>
              <p>
                On each fund profile page, we also display the
                highest & lowest-scored holdings for each of the four
                equity & justice ratings.
                This can be used to identify the leaders and laggards
                within the portfolio on each issue.
              </p>
            </div>

            <h3 styleName='answer-title'>
              Sustainable funds
            </h3>
            <div styleName='answer-info'>
              <img
                styleName='sri'
                src={sriIcon}
                alt='Sustainably-mandated  fund'
                data-multiline
                data-effect='solid'
                data-html
                data-for='sri-icons-tooltip'
                data-place='bottom'
                data-tip="<div style='max-width:200px;'>Designated a sustainably-mandated fund by Morningstar. Sustainably-mandated funds consider issues like the environment and human rights.</div>"
              />
              <ReactTooltip id='sri-icons-tooltip'/>
              <p>
                We use Morningstar's "sustainability mandate" indicator to determine which funds are displayed as sustainably-mandated. Sustainably-mandated funds make investment decisions based on issues like environmental responsibility, human rights, or religious views. A sustainably-mandated fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting fossil fuels, or firearms, or in the defense industry. Look for this symbol to find funds that are designated sustainably-mandated.
              </p>
              <img
                styleName='ussif'
                src={ussifIcon}
                alt='Member of US-SIF, the Forum for Sustainable and Responsible Investment'
                data-multiline
                data-effect='solid'
                data-html
                data-for='ussif-icons-tooltip'
                data-place='bottom'
                data-tip="<div style='max-width:200px;'>Member of US-SIF, the Forum for Sustainable and Responsible Investment</div>"
              />
              <ReactTooltip id='ussif-icons-tooltip'/>
              <p>
                The Forum for Sustainable and Responsible Investment is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have strong policies to integrate social issues into investment decisions. Look for this symbol to find funds that are members of US-SIF.
              </p>
            </div>

            <h3 styleName='answer-title'>
              Action toolkit
            </h3>
            <div styleName='answer-info'>
              <p>
                When you're done looking up funds and finding the data you need, what's next? You can learn how to make a change and move your money with our <Link to={config.routes.toolkit} xstrong title='Action toolkit'>action toolkit</Link>. Whether you’re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There's an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more &mdash; everything you need to make a change and get started investing aligned with your values.
              </p>
            </div>

            <ScrollToTop />
          </section>

          { /* CHANGELOG */ }
          <section styleName='methodology-section'>
            <div styleName='anchor' id='spreadsheet'/>
            <h2 styleName='section-title'>
              Spreadsheet
            </h2>
            <Changelog />
            <ScrollToTop />
          </section>

        </ContainerDivs>
        <br/>
        <br/>
        <br/>

        <GetStartedInput />
      </div>
    )
  }
}
